// ==========================================
// SELLERSUPPORT.JSX - SUPPORT TICKET SYSTEM
// Estate Experts - Seller Support Component
// Updated: Modal form, Details left, Tickets right
// ==========================================

import React, { useContext, useEffect, useState } from "react";
import {
  FaEdit,
  FaEllipsisV,
  FaPaperclip,
  FaPaperPlane,
  FaFilePdf,
  FaImage,
  FaDownload,
  FaTimes,
  FaPlus,
  FaUserShield,
} from "react-icons/fa";
import "../../../assets/css/sellers/dashboard/sellersupports/helpsupports.css";
import SellerMasterLayout from "../../../layouts/SellerMasterLayout";
import AppContext from "context/AppContext";
import axios from "axios";
import Swal from "sweetalert2";

const HelpSupport = () => {
  // ====== STATE MANAGEMENT ======
  const [activeTicket, setActiveTicket] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [subject, setSubject] = useState();
  const [category, setCategory] = useState();
  const [property, setProperty] = useState();
  const [description, setDescription] = useState();
  const [replyMessage, setReplyMessage] = useState("");
  const [replyAttachments, setReplyAttachments] = useState([]);
  const [conversation, setConversation] = useState(null);
  const [messages, setMessages] = useState([]);
  const [conversationIDForChat, setConversationIDForChat] = useState();
  const [loading, setLoading] = useState(true);
  const [conversationLoading, setConversationLoading] = useState(false);
  const { loggedInSeller, baseUrl, authToken } = useContext(AppContext);

  // ====== DUMMY DATA - Tickets ======
  const [tickets, setTickets] = useState([]);

  // ====== FORM STATE ======
  const [formErrors, setFormErrors] = useState({});
  const [buyersList, setBuyersList] = useState([]);



  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [against, setAgainst] = useState("");
  const [respondentId, setRespondentId] = useState("");
  const [sellersList, setSellersList] = useState([]); // dropdown ke liye
  const [properties, setProperties] = useState([
    {
      id: "prop1",
      property_title: "Luxury Villa in DHA Phase 5",
      created_at: "2024-03-10",
    },
    {
      id: "prop2",
      property_title: "Modern Apartment in Gulberg III",
      created_at: "2024-02-20",
    },
    {
      id: "prop3",
      property_title: "Commercial Plot F-8",
      created_at: "2024-01-05",
    },
  ]);

  // ====== CATEGORY OPTIONS ======
  const categories = [
    "Property Issue",
    "Listing Problem",
    "Payment / Commission",
    "Buyer Communication",
    "Account / Login",
    "Other",
  ];
  useEffect(() => {
    if (against === "buyer" && buyersList.length === 0) {
      fetchAllBuyers();
    }
  }, [against]);
  const fetchAllBuyers = () => {
    const formData = new FormData();
    formData.append("exseller_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/seller/helpsupport/fetchAllBuyers`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        if (res.data.success == true) {
          setBuyersList(res.data.buyers);
        }
      })
      .catch((err) => console.log(err));
  };

  // ====== MODAL HANDLERS ======
  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const fetchAllTickets = () => {
    setLoading(true);

    if (!loggedInSeller?.id) {
      setLoading(false);
      return;
    }

    const formData = new FormData();
    formData.append("exseller_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/seller/helpsupport/fetchAllTickets`, formData, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      })
      .then((res) => {
        console.log("All tickets response:", res.data);

        if (res.data.success === true) {
          setTickets(res.data.tickets || []);
        } else {
          setTickets([]);
          console.log("Tickets API message:", res.data.message);
        }
      })
      .catch((err) => {
        console.log("Fetch tickets error:", err);
        console.log("Error response:", err.response?.data);
        setTickets([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const submitTicket = () => {
    console.log(
      "submit ticket wala function chl rha ha",
      subject,
      category,
      description,
      property,
    );

    if (!subject || !category || !description) {
      alert("Please fill all required fields!");
      return;
    }

    const formData = new FormData();
    formData.append("exseller_id", loggedInSeller?.id);
    formData.append("subject", subject);
    formData.append("category", category);
    formData.append("description", description);
    formData.append("exproperty_id", property);
    formData.append("raisedby", "seller");
    formData.append("against", against); // ✅ ab bhej rahe hain
    if (against === "seller") {
      formData.append("respondent_id", respondentId); // ✅ kis seller ke against
    }
    if (against === "buyer" && respondentId) {
      formData.append("respondent_id", respondentId);
    }
    axios
      .post(`${baseUrl}/seller/helpsupport/createTicket`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          Swal.fire({
            icon: "success",
            title: "Okay",
            confirmButtonText: "success",
          });
          fetchAllTickets();
          closeModal();
          // Reset form
          setSubject("");
          setCategory("");
          setProperty("");
          setDescription("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchSellerProperties = () => {
    const formData = new FormData();
    formData.append("exseller_id", loggedInSeller.id);
    axios
      .post(`${baseUrl}/seller/helpsupport/fetchSellerProperties`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((response) => {
        console.log(response.data.properties);

        setProperties(response.data.properties);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (against === "seller" && sellersList.length === 0) {
      fetchAllSellers();
    }
  }, [against]);
  const fetchAllSellers = () => {
    const formData = new FormData();
    formData.append("exseller_id", loggedInSeller.id);

    axios
      .post(`${baseUrl}/seller/helpsupport/fetchAllSellers`, formData, {
        headers: {
          "Content-Type": "multipart/formdata",
          "Authorization": `Bearer ${authToken}`
        },
      })
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setSellersList(res.data.sellers);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

 const fetchConversation = (conversationId) => {
  if (!conversationId) {
    setConversation(null);
    setMessages([]);
    setConversationIDForChat(null);
    return;
  }

  setConversationLoading(true);

  const formData = new FormData();

  formData.append(
    "exconversation_id",
    conversationId
  );

  axios
    .post(
      `${baseUrl}/seller/helpsupport/fetchConversation`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
    .then((res) => {
      console.log("Seller support conversation:", res.data);

      if (res.data.success) {
        setConversation(res.data.conversation);
        setMessages(res.data.messages || []);
      } else {
        setConversation(null);
        setMessages([]);
      }
    })
    .catch((err) => {
      console.log("Seller conversation error:", err);
      setConversation(null);
      setMessages([]);
    })
    .finally(() => {
      setConversationLoading(false);
    });
};

  const sendMessage = () => {
  if (!conversationIDForChat) {
    Swal.fire({
      icon: "warning",
      title: "No Conversation",
      text: "Please select a ticket first.",
    });
    return;
  }

  if (!replyMessage.trim()) {
    return;
  }

  const formData = new FormData();

  formData.append(
    "exconversation_id",
    conversationIDForChat
  );

  formData.append(
    "message",
    replyMessage.trim()
  );

  axios
    .post(
      `${baseUrl}/seller/helpsupport/sendMessage`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    )
    .then((res) => {
      console.log("Seller support message:", res.data);

      if (res.data.success) {
        setReplyMessage("");

        fetchConversation(
          conversationIDForChat
        );
      }
    })
    .catch((err) => {
      console.log("Seller send message error:", err);

      Swal.fire({
        icon: "error",
        title: "Message Not Sent",
        text:
          err.response?.data?.message ||
          "Something went wrong.",
      });
    });
};


  const handleReplyFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setReplyAttachments([...replyAttachments, ...files]);
  };

  const removeReplyAttachment = (index) => {
    setReplyAttachments(replyAttachments.filter((_, i) => i !== index));
  };

  // ====== STATUS COLOR FUNCTION ======
  const getStatusClass = (status) => {
    switch (status) {
      case "Open":
        return "sellersupport-status-open";
      case "In Progress":
        return "sellersupport-status-progress";
      case "Resolved":
        return "sellersupport-status-resolved";
      case "Closed":
        return "sellersupport-status-closed";
      default:
        return "";
    }
  };

 useEffect(() => {
  if (!loggedInSeller?.id) return;
  fetchAllTickets();
  fetchSellerProperties();
}, [loggedInSeller?.id]);

  // ====== SEND TO ADMIN HANDLER ======
  const handleSendToAdmin = () => {
    if (
      window.confirm(`Send ticket ${activeTicket} to admin for resolution?`)
    ) {
      console.log("Ticket sent to admin:", activeTicket);
      alert(
        "Ticket successfully sent to admin! You will receive a response soon.",
      );
    }
  };

  const currentTicket =
    tickets.find((ticket) => ticket.id === activeTicket) || null;

  return (
    <SellerMasterLayout pageTitle="Support Ticket">
      {loading ? (

        <div className="sellersupport-loading">
          <div className="sellersupport-loader-spinner"></div>

          <p className="sellersupport-loading-text">
            Loading your support tickets...
          </p>
        </div>

      ) : (

        <div className="sellersupport-page">
          <div className="sellersupport-container">
            {/* ==========================================
              RIGHT SIDEBAR - MY TICKETS LIST
          ========================================== */}
            <div className="sellersupport-sidebar">
              <div className="sellersupport-tickets-section">
                <div className="sellersupport-tickets-header">
                  <h2 className="sellersupport-section-title">My Tickets</h2>
                  <button
                    className="sellersupport-create-ticket-btn"
                    onClick={openModal}
                  >
                    <FaPlus /> Create Ticket
                  </button>
                </div>

                <div className="sellersupport-table">
                  {/* Table Header */}
                  <div className="sellersupport-table-header">
                    <div className="sellersupport-th">ID</div>
                    <div className="sellersupport-th">Subject</div>
                    <div className="sellersupport-th">Status</div>
                    <div className="sellersupport-th">Action</div>
                  </div>

                  {/* Table Rows */}
                  {tickets.map((ticket) => (
                    <div
                      key={ticket.id}
                      className={`sellersupport-table-row ${activeTicket === ticket.id ? "active" : ""
                        }`}
                    >
                      <div className="sellersupport-td">{ticket.id}</div>
                      <div className="sellersupport-td">{ticket.subject}</div>
                      <div className="sellersupport-td">
                        <span
                          className={`sellersupport-status ${getStatusClass(
                            ticket.status,
                          )}`}
                        >
                          {ticket.status}
                        </span>
                      </div>
                      <div className="sellersupport-td">
                        <button
  onClick={() => {
    setActiveTicket(ticket.id);

    const conversationId =
      ticket.exconversation?.id;

    setConversationIDForChat(
      conversationId || null
    );

    if (conversationId) {
      fetchConversation(conversationId);
    } else {
      setConversation(null);
      setMessages([]);
    }
  }}
  className="sellersupport-view-btn"
>
  View →
</button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* ==========================================
              LEFT SIDE - TICKET DETAILS
          ========================================== */}
            <div className="sellersupport-main">
              {currentTicket ? (
                <div className="sellersupport-details-section">
                  {/* Header */}
                  <div className="sellersupport-details-header">
                    <div className="sellersupport-details-title">
                      <h3>Ticket Details</h3>
                      <div className="sellersupport-header-actions">
                        <button className="sellersupport-icon-btn">
                          <FaEdit />
                        </button>
                        <button className="sellersupport-icon-btn">
                          <FaEllipsisV />
                        </button>
                      </div>
                    </div>

                    {/* Ticket Info Bar */}
                    <div className="sellersupport-ticket-info">
                      <div className="sellersupport-ticket-id">
                        <strong>Ticket ID: {currentTicket.id}</strong>
                        <span className="sellersupport-divider">|</span>
                        <span>{currentTicket.subject}</span>
                      </div>
                      <div className="sellersupport-ticket-meta">
                        <span
                          className={`sellersupport-status ${getStatusClass(
                            currentTicket.status,
                          )}`}
                        >
                          Status: {currentTicket.status}
                        </span>
                      </div>
                    </div>

                    {/* Progress Dots */}
                    <div className="sellersupport-progress-dots">
                      <span className="sellersupport-dot active"></span>
                      <span className="sellersupport-dot active"></span>
                      <span className="sellersupport-dot active"></span>
                      <span className="sellersupport-dot"></span>
                      <span className="sellersupport-dot"></span>
                      <span className="sellersupport-dot"></span>
                    </div>
                  </div>

                  {/* Conversation */}
                  <div className="sellersupport-conversation">
                    {messages.map((msg) => (
                      <div
                        key={msg.id}
                        className={`sellersupport-message ${msg.sender === "exseller"
                          ? "sellersupport-message-user"
                          : "sellersupport-message-support"
                          }`}
                      >
                        <div className="sellersupport-message-content">
                          <div className="sellersupport-message-header">
                            <strong>
                              {msg.sender === "exseller" ? "You" : "Support Team"}
                            </strong>
                          </div>

                          <p className="sellersupport-message-text">
                            {msg.massage}
                          </p>
                        </div>
                      </div>
                    ))}

                    {/* Shared Attachments */}
                    {currentTicket.sharedAttachments?.length > 0 && (
                      <div className="sellersupport-attachments">
                        {currentTicket.sharedAttachments.map((file, idx) => (
                          <div
                            key={idx}
                            className="sellersupport-attachment-item"
                          >
                            {file.type === "pdf" ? <FaFilePdf /> : <FaImage />}
                            <span className="sellersupport-attachment-name">
                              {file.name}
                            </span>
                            <button className="sellersupport-download-btn">
                              <FaDownload />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  {/* Reply Section */}
                  <div className="sellersupport-reply-input-wrapper">
                    <input
                      type="text"
                      placeholder="Add a Reply..."
                      value={replyMessage}
                      onChange={(e) => setReplyMessage(e.target.value)}
                      className="sellersupport-reply-input"
                    />
                    <label className="sellersupport-attach-btn">
                      <FaPaperclip />
                      <input
                        type="file"
                        multiple
                        onChange={handleReplyFileUpload}
                        style={{ display: "none" }}
                      />
                    </label>
                    <button
                      onClick={() => {
                        sendMessage();
                      }}
                      className="sellersupport-send-btn"
                    >
                      Send <FaPaperPlane />
                    </button>
                  </div>

                  {replyAttachments?.length > 0 && (
                    <div className="sellersupport-reply-attachments">
                      {replyAttachments.map((file, idx) => (
                        <div key={idx} className="sellersupport-reply-file">
                          <span>{file.name}</span>
                          <FaTimes onClick={() => removeReplyAttachment(idx)} />
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="sellersupport-details-section"
                  style={{ padding: "4rem", textAlign: "center" }}
                >
                  <h3>Select a ticket to view details</h3>
                </div>
              )}
            </div>
          </div>

          {/* ==========================================
            CREATE TICKET MODAL - ADVANCED DESIGN
        ========================================== */}
          {isModalOpen && (
            <div className="sellersupport-modal-overlay" onClick={closeModal}>
              <div
                className="sellersupport-modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="sellersupport-modal-header">
                  <h2 className="sellersupport-modal-title">
                    Create Support Ticket
                  </h2>
                  <button
                    className="sellersupport-modal-close-btn"
                    onClick={closeModal}
                  >
                    <FaTimes />
                  </button>
                </div>

                <div className="sellersupport-modal-body">
                  {submitSuccess && (
                    <div className="ct-success-banner">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                        }}
                      >
                        <span style={{ color: "#28a745", fontSize: "16px" }}>
                          ✓
                        </span>
                        <span>
                          Ticket successfully submitted! Support team will respond
                          soon.
                        </span>
                      </div>
                    </div>
                  )}

                  <div className="ct-warning-notice">
                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "flex-start",
                      }}
                    >
                      <span
                        style={{
                          color: "#f59e0b",
                          fontSize: "16px",
                          marginTop: "2px",
                        }}
                      >
                        ⚠
                      </span>
                      <div>
                        <strong>Important Notice:</strong>
                        <p
                          style={{
                            margin: "5px 0 0 0",
                            color: "#666",
                            fontSize: "14px",
                          }}
                        >
                          Please provide accurate details about your issue. Our
                          support team will review and respond within 24-48 hours.
                        </p>
                      </div>
                    </div>
                  </div>

                  <form className="sellersupport-form">
                    {/* Category */}
                    <div className="sellersupport-form-group">
                      <label>
                        Category <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <div className="ct-select-wrap">
                        <select
                          className="sellersupport-form-group-select"
                          value={category}
                          onChange={(e) => setCategory(e.target.value)}
                          required
                        >
                          <option value="">Select Category</option>
                          {categories.map((cat, idx) => (
                            <option key={idx} value={cat}>
                              {cat}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Subject */}
                    <div className="sellersupport-form-group">
                      <label>
                        Subject <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <input
                        type="text"
                        className={`sellersupport-form-input ${formErrors.subject ? "ct-input-error" : ""}`}
                        placeholder="e.g. Property listing not visible"
                        value={subject}
                        onChange={(e) => {
                          setSubject(e.target.value);
                          setFormErrors({ ...formErrors, subject: "" });
                        }}
                        required
                      />
                      {formErrors.subject && (
                        <span className="ct-error-msg">{formErrors.subject}</span>
                      )}
                    </div>
                    {/* ✅ YAHAN NAYA BLOCK - Against Field */}
                    <div className="sellersupport-form-group">
                      <label>
                        Complaint Against{" "}
                        <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <div className="ct-select-wrap">
                        <select
                          className="sellersupport-form-group-select"
                          value={against}
                          onChange={(e) => {
                            setAgainst(e.target.value);
                            setRespondentId(""); // reset jab against change ho
                          }}
                          required
                        >
                          <option value="">Select Against</option>
                          <option value="buyer">Buyer</option>
                          <option value="seller">Another Seller</option>
                        </select>
                      </div>
                    </div>

                    {/* ✅ Agar "seller" select ho, to respondent (kaunsa seller) bhi choose karwao */}
                    {against === "seller" && (
                      <div className="sellersupport-form-group">
                        <label>
                          Select Seller{" "}
                          <span style={{ color: "#dc3545" }}>*</span>
                        </label>
                        <div className="ct-select-wrap">
                          <select
                            className="sellersupport-form-group-select"
                            value={respondentId}
                            onChange={(e) => setRespondentId(e.target.value)}
                            required
                          >
                            <option value="">-- Select seller --</option>
                            {sellersList.map((s) => (
                              <option key={s.id} value={s.id}>
                                {s.firstName} {s.lastName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}
                    {/* ✅ Agar "buyer" select ho, to respondent (kaunsa buyer) bhi choose karwao */}
                    {against === "buyer" && (
                      <div className="sellersupport-form-group">

                        <label>
                          Select Buyer <span style={{ color: "#dc3545" }}>*</span>
                        </label>
                        <div className="ct-select-wrap">
                          <select value={respondentId} onChange={(e) => setRespondentId(e.target.value)}>
                            <option value="">-- Select buyer --</option>
                            {buyersList.map((b) => (
                              <option key={b.id} value={b.id}>
                                {b.firstName} {b.lastName}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}

                    {/* Related Property Section */}
                    {category && category !== "Account / Login" && (
                      <div className="ct-dispute-section">
                        <div className="ct-dispute-section-header">
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              fontSize: "14px",
                              fontWeight: "600",
                            }}
                          >
                            📋 Related Property
                          </span>
                        </div>
                        <div className="sellersupport-form-group">
                          <label>
                            Select Property{" "}
                            <span style={{ color: "#dc3545" }}>*</span>
                          </label>
                          <div className="ct-select-wrap">
                            <select
                              className={`sellersupport-form-group-select ${formErrors.property ? "ct-input-error" : ""}`}
                              value={property}
                              onChange={(e) => {
                                setProperty(e.target.value);
                                setFormErrors({ ...formErrors, property: "" });
                              }}
                            >
                              <option value="">-- Select your property --</option>
                              {properties.map((singleProperty) => (
                                <option
                                  key={singleProperty.id}
                                  value={singleProperty.id}
                                >
                                  {singleProperty.property_title} — Listed:{" "}
                                  {singleProperty.created_at}
                                </option>
                              ))}
                            </select>
                          </div>
                          {formErrors.property && (
                            <span className="ct-error-msg">
                              {formErrors.property}
                            </span>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Description */}
                    <div className="sellersupport-form-group">
                      <label>
                        Description <span style={{ color: "#dc3545" }}>*</span>
                      </label>
                      <textarea
                        className={`sellersupport-form-textarea ${formErrors.description ? "ct-input-error" : ""}`}
                        rows={5}
                        placeholder="Please describe your issue in detail. Include when it started and any relevant information..."
                        value={description}
                        onChange={(e) => {
                          setDescription(e.target.value);
                          setFormErrors({ ...formErrors, description: "" });
                        }}
                        required
                      ></textarea>
                      {formErrors.description && (
                        <span className="ct-error-msg">
                          {formErrors.description}
                        </span>
                      )}
                    </div>

                    {/* Form Actions */}
                    <div className="ct-modal-footer-actions">
                      <button
                        type="button"
                        className="sellersupport-btn-cancel"
                        onClick={closeModal}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="sellersupport-submit-btn"
                        onClick={submitTicket}
                        disabled={submitSuccess}
                      >
                        <FaPaperPlane style={{ marginRight: "8px" }} />
                        Submit Ticket
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </SellerMasterLayout>
  );
};

export default HelpSupport;
